import React, { memo, FC, useCallback } from 'react';

export interface UnselectedItemProps {
  children: string;
  className: string;
  id: number;
  disabled: boolean;
  onSelect: (optionId: number) => void;
}

const UnselectedItem: FC<UnselectedItemProps> = ({
  children,
  className,
  id,
  disabled,
  onSelect
}) => {
  const onClick = useCallback(() => onSelect(id), [onSelect, id]);
  return (
    <div className={className} onClick={disabled ? undefined : onClick}>
      {children}
    </div>
  );
};

export default memo(UnselectedItem);
